export let translations = {
	// put translations in DE here
	"[[Cotton]]": "Baumwolle",
	"[[Polyester]]": "Polyester",
	"[[Spandex]]": "Elasthan",
	"[[Other]]": "Anderes",
	"[[Upcycled Polyester]]": "Upcycling-Polyester",
	"[[Linen]]": "Leinen",
	"[[Bamboo]]": "Bamboo",
	"[[Tencel]]": "Tencel",
	"[[Rayon]]": "Viskose",
	"available": "Verfügbar",
	"soon_sold_out_coming_back": "Bald ausverkauft - (zurück ca. {note})",
	"soon_sold_out_not_coming_back": "Bald ausverkauft - Kommt nicht wieder",
	"sold_out_coming_back": "Ausverkauft - (zurück ca. {note})",
	"sold_out_not_coming_back": "Ausverkauft - Kommt nicht wieder",
	"inactive": "Inaktiv - {note}",
}